
export const PAGE_GAP = 10;

export const ALERT_HEIGHT = 72;
export const TOP_GAP = PAGE_GAP;
export const PRODUCT_HEADER_HEIGHT = 91;
export const PRODUCT_HEADER_EXPANDED_HEIGHT = 337;
export const CONTENT_HEADER_HEIGHT = 80;
export const CONTENT_HEIGHT = '1fr';
export const BOTTOM_GAP = PAGE_GAP;

export const LEFT_GAP = PAGE_GAP;
export const SIDEBAR_WIDTH = 103;
export const EXPANDED_SIDEBAR_WIDTH = 236;
export const CONTENT_WIDTH = '1fr';
export const RIGHT_GAP = PAGE_GAP;

export const AREA_OPACITY = 0.2;

export const GRADIENT_HEIGHT = 25;

export const SUB_PAGE_WIDTHS = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE_FLUID: 'large-fluid',
  HALF_CLAMPED: 'half-clamped',
  MEDIUM_FIXED: 'medium-fixed',
  LARGE: 'large',
  LARGE_FIXED: 'large-fixed',
  EXTRA_LARGE: 'extra-large',
};
